import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=309c79f6&"
import script from "./NotesCard.vue?vue&type=script&lang=js&"
export * from "./NotesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports